export default "__VITE_ASSET__CKFzxwYQ__"